// src/data/projectContent.js

const tokenUseCasesProject = [
    {
      title: "Casos de Uso Avanzados en Tokenización",
      value: `
  ##  Tokenización de Activos Reales
  
  Los **activos reales** incluyen:
  
  - Bienes raíces
  - Obras de arte
  - Empresas
  
  Estos activos pueden beneficiarse enormemente de:
  
  - Mayor **transparencia**
  - Mayor **liquidez**
  - **Propiedad fraccionada** en blockchain
  
  A pesar de ser fungibles en su tokenización, también pueden implicar requisitos legales y fiscales complejos que son **más fáciles de manejar con contratos inteligentes y sistemas basados en blockchain**.
  
  ---
  
  ##  Tokenización en el Entretenimiento
  
  La industria del cine, la música y el entretenimiento en general está viviendo una **transformación acelerada**:
  
  - El **poder se redistribuye** entre productores, directores, actores, distribuidores y espectadores.
  - Se está redefiniendo **cómo se financian y distribuyen** las obras, así como **cómo se reparten los ingresos**.
  
  La tokenización facilita:
  
  - Participación activa de los fans
  - Acceso a **tokens de participación en películas o licencias**
  - Sistemas de regalías automáticas
  
  ---
  
  ##  Deportes y Participación de Fans
  
  La tokenización de activos dentro del ecosistema deportivo y de gaming permite:
  
  - Fraccionar la propiedad de equipos o elementos de juego
  - Crear tokens para fans que representan experiencias exclusivas
  - Atraer a nuevos inversores y audiencias jóvenes
  
  > Cambiará para siempre la forma en que participamos como inversores y aficionados.
  
  ---
  
  ##  Tokenización de Recursos Naturales
  
  Empresas de exploración y minería pueden:
  
  - Emitir tokens respaldados por activos (commodities, terrenos, futuros de producción)
  - Usar blockchain como plataforma para **captar capital de inversión**
  
  Este modelo permite:
  
  - **Acceso global a inversores**
  - Reducción de barreras geográficas y burocráticas
  - Liquidez anticipada para proyectos que tradicionalmente eran ilíquidos
  
  ---
  
  ##  El Caso Amazon: Lecciones para la Blockchain
  
  Amazon cambió la historia del comercio:
  
  - En su momento, pocos creían que la gente compraría todo en línea
  - Pero el costo, la conveniencia y el alcance global ganaron
  
  Del mismo modo, **la tokenización transformará los mercados de valores y activos físicos**, volviéndose una **elección lógica** por sus ventajas tecnológicas, económicas y legales.
  
  > Así como Amazon reemplazó al retail físico, blockchain y los tokens reestructurarán el mercado financiero tradicional.
      `,
    },
  ];
  
  export default tokenUseCasesProject;
  